import { render, staticRenderFns } from "./fishing-free-point.vue?vue&type=template&id=6005ab4e&scoped=true"
import script from "./fishing-free-point.vue?vue&type=script&lang=js"
export * from "./fishing-free-point.vue?vue&type=script&lang=js"
import style0 from "./fishing-free-point.vue?vue&type=style&index=0&id=6005ab4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005ab4e",
  null
  
)

export default component.exports